import { useCallback, useEffect, useState } from 'react';
import { latestReads, useLiveRefresh } from '../../live/useLive';

// This tab's own saves: the live stream does not echo them back to the tab
// that made them, so the Tickets page and "Submit a ticket" announce them.
export const TICKETS_CHANGED = 'globalops:tickets-changed';
export const ticketsChanged = () => window.dispatchEvent(new Event(TICKETS_CHANGED));

/**
 * The sidebar's Tickets badge: tickets still to do (Open + In progress).
 * Off (0) for people without the Tickets area, and when the read fails.
 */
export function useOpenTicketCount(enabled) {
  const [count, setCount] = useState(0);
  const [reads] = useState(latestReads);
  const load = useCallback(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    const ticket = reads.start();
    fetch('/api/tickets/summary')
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => {
        if (reads.show(ticket) && s) setCount((s.open || 0) + (s.in_progress || 0));
      })
      .catch(() => {});
  }, [enabled, reads]);
  useEffect(load, [load]);
  useEffect(() => {
    window.addEventListener(TICKETS_CHANGED, load);
    return () => window.removeEventListener(TICKETS_CHANGED, load);
  }, [load]);
  useLiveRefresh(['tickets', 'feedback'], load);
  return count;
}
